module.exports = __webpack_public_path__ + "static/media/live-casino-games-ru.b3136a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/jacktop-games/live-casino-games-ru.png
// module id = 906
// module chunks = 7